<div *ngIf="false" class="container-fluid">
    <div class="row" style="padding-left: 10%; padding-top: 6%;">
        <div class="col-8">
            <div class="form-group green-border-focus">
                <div class="alert alert-primary" role="alert">Customer
                    Payment Hub Data</div>
                <form>
                    <textarea class="form-control" rows="15" id="payhubdata" #payhubdata></textarea>
                    <button type="button" class="btn btn-primary" (click)="onSubmit(payhubdata)">Submit</button>
                </form>
            </div>
        </div>
    </div>
</div>

<ng-template #content let-c="close" let-d="dismiss" let-modal>
    <div class="modal-content">
        <div class="modal-body ">
            <div class="modal-box">
                <!-- popup-header -->
                <div class="custom-header">
                    <div class="title">Select Customer</div>
                    <div class="subtitle"></div>
                    <button type="button" class="close" data-dismiss="modal" (click)="modal.dismiss()">&times;</button>
                </div>
                <div class="row">
                    <div class="col">
                        <div ngbDropdown class="d-inline-block">
                            <button class="btn btn-outline-primary" id="dropdownCustomers"
                                ngbDropdownToggle>{{selectedCustomers}}</button>
                            <div ngbDropdownMenu aria-labelledby="dropdownCustomers">
                                <button ngbDropdownItem *ngFor="let customer of data.customers"
                                    (click)="onselectedCustomer(data, customer)">{{customer.name}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<payment-hub *ngIf="paymentHubData !=  undefined" [suppliedPaymentHubData]="paymentHubData" [suppliedPayloadData]="payLoadData"></payment-hub>
